import type { GridSelection, Item, Rectangle } from "@artis/data-grid";
import { useCallback, useRef } from "react";

type ClearDeps = {
  getSource: (cell: Item) => string;
  setValue: (cell: Item, raw: string) => void;
  transact: (fn: () => void) => void;
  rowCount: number;
  colCount: number;
};

export function useClearCells(deps: ClearDeps) {
  const depsRef = useRef(deps);
  depsRef.current = deps;

  return useCallback((selection: GridSelection): boolean => {
    const { getSource, setValue, transact, rowCount, colCount } = depsRef.current;
    const rects: Rectangle[] = [];
    if (selection.current) rects.push(selection.current.range, ...selection.current.rangeStack);
    for (const row of selection.rows) rects.push({ x: 0, y: row, width: colCount, height: 1 });
    for (const col of selection.columns) rects.push({ x: col, y: 0, width: 1, height: rowCount });
    if (rects.length === 0) return false;

    transact(() => {
      for (const rect of rects) {
        for (let r = 0; r < rect.height; r++) {
          for (let c = 0; c < rect.width; c++) {
            const cell: Item = [rect.x + c, rect.y + r];
            if (getSource(cell) !== "") setValue(cell, "");
          }
        }
      }
    });
    return true;
  }, []);
}
